'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { useI18n } from '@/modules/i18n/useI18n';
import ErrorPage from '@/payload/components/ErrorPage/ErrorPage';

export default function ErrorLayout({ error }: { error: Error & { digest?: string } }) {
	const { terms } = useI18n();

	useEffect(() => {
		Sentry.captureException(error);
	}, [error]);

	return (
		<main data-tag-page-section="error">
			<ErrorPage title={terms.error.title} description={terms.error.description} label={terms.error.label} />
		</main>
	);
}
